import type { FaqEntry } from '@/components/ui/faq'

export const FAQ_CONTENT: FaqEntry[] = [
  {
    question: 'What do I need before I can publish my booking page?',
    answer:
      'Finish setup with a profile, service area, weekly hours, at least one active service, and connected Google or Outlook calendar sync.',
  },
  {
    question: 'How does Zippity decide whether a customer can book me?',
    answer:
      'Customers must enter a service address. Zippity checks your service area and then only shows slots that can fit your schedule, existing appointments, and travel constraints.',
  },
  {
    question: 'Is calendar sync required?',
    answer:
      'Yes. Launch readiness requires a connected Google Calendar or Outlook account so external busy events can block booking slots. Appointment writeback is enabled by default.',
  },
  {
    question: 'What happens when I go live?',
    answer:
      'Your selected booking artifact becomes public, and customers can use your /book page. Draft, preview, paused, and payment-pending states are not public.',
  },
  {
    question: 'Where do I manage billing?',
    answer:
      'Use Billing for Pro, Pay-as-you-go, payment method setup, invoices, and subscription changes. Pay-as-you-go still needs a valid card before going live.',
  },
]
